var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-field',{attrs:{"label":_vm.label}},[_c('q-input-frame',{staticClass:"q-input q-if-focusable",attrs:{"color":_vm.color}},[(this.value)?_c('span',{domProps:{"innerHTML":_vm._s(this.value)},on:{"click":_vm.redirect}}):_vm._e()])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2339226a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form/VLastOrder.vue
// module id = RjlX
// module chunks = 83